export default __webpack_public_path__ + "static/media/dashboard_lecture_2.7d49dcc8.png";